import { initializeApp } from 'firebase/app'
import credentials from './credentials'

// Initialize Firebase (modular API)
export const firebaseApp = initializeApp(credentials.firebase)
